<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb> 
          <BreadcrumbItem>tips</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">tips</div>
      </div>
    </div>

    <div class="layout-content" style="padding:40px;min-height: 500px;">
      <div v-html="info.text" v-if="info"></div>
      <div class="u-empty" v-else>no date</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  data () {
    return {
      info: null,
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      exhibition: 'loginModule/getExhibition',
    }),
  },
  methods: {
    ...mapActions({
      getExhibitionPayAttentionByExId: "registerdModule/getExhibitionPayAttentionByExId",
    }),
    async getExhibitionPayAttentionHandle () {
      let res = await this.getExhibitionPayAttentionByExId(this.exhibition.id);
      if (res) {
        this.info = res;
      }
      console.log('getExhibitionPayAttentionHandle', res);
    },
  },
  created () {
    this.getExhibitionPayAttentionHandle();

  },
  mounted () { }
}

</script>

<style lang="scss" scoped>
</style>
